import { get, post, put, del } from '@api/request';

export async function fetchStrataConfigurations(
  { ptdService },
  authenticationToken,
  { year },
) {
  const url = `${ptdService}/ptd/salestratificationconfigurations/${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchStrataConfigurationByTaxingUnit(
  { ptdService },
  authenticationToken,
  { year, taxingUnitID },
) {
  const url = `${ptdService}/ptd/salestratificationconfigurations/${taxingUnitID}/${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchStrataStateCodes(
  { ptdService },
  authenticationToken,
) {
  const url = `${ptdService}/ptd/statecodes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertStrataConfiguration(
  { ptdService },
  authenticationToken,
  { payload },
) {
  const url = `${ptdService}/ptd/salestratificationconfigurations`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateStrataConfiguration(
  { ptdService },
  authenticationToken,
  { payload, configID },
) {
  const url = `${ptdService}/ptd/salestratificationconfiguration/${configID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteStrataConfiguration(
  { ptdService },
  authenticationToken,
  { configID },
) {
  const url = `${ptdService}/ptd/salestratificationconfiguration/${configID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchStrataRuns({ ptdService }, authenticationToken) {
  const url = `${ptdService}/ptd/salestratificationruns`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteStrataRun({ ptdService }, authenticationToken, { runID }) {
  const url = `${ptdService}/ptd/salestratificationrun/${runID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchStrataTaxingUnits(
  { ptdService },
  authenticationToken,
  { year },
) {
  const url = `${ptdService}/ptd/salestratificationconfigurations/${year}/availabletaxingunits`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createStrataRun(
  { ptdService },
  authenticationToken,
  { payload },
) {
  const url = `${ptdService}/ptd/salestratificationruns`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchStrataRunTaxingUnits(
  { ptdService },
  authenticationToken,
  { runID },
) {
  const url = `${ptdService}/ptd/salestratificationrun/${runID}/taxingunits`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchStrataRunTaxingUnitDetail(
  { ptdService },
  authenticationToken,
  { runID, taxingUnitID },
) {
  const url = `${ptdService}/ptd/salestratificationrun/${runID}/summarybytaxingunit/${taxingUnitID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchStrataRunCategoryDetail(
  { ptdService },
  authenticationToken,
  { detalID },
) {
  const url = `${ptdService}/ptd/salestratificationrun/strata/${detalID}/sales`;
  const { body } = await get(authenticationToken, url);
  return body;
}
